import { toast } from "react-toastify";
import API from "./../../helpers/api/api_interceptor";
import { ADD_TEMPLATE, DELETE_TEMPLATE, SET_TEMPLATES_LIST, UPDATE_TEMPLATE } from "./actionTypes";

export const getTemplates = (params) => async (dispatch) => {
  try {
    return API.get(`/lots/templates`, {
      params: {
        page_number: params?.page,
        page_size: params?.limit,
        search: params?.search,
        sort: params?.sort,
        filter: params?.filter,
      },
    }).then((res) => {
      if (res && res.status && res.status === 200) {
        dispatch({
          type: SET_TEMPLATES_LIST,
          payload: {
            data: res?.data?.data?.results,
            total: res?.data?.data?.count,
          },
        });
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

// to add template
export const addTemplate = (payload) => async (dispatch) => {
  const formData = new FormData();
  formData.append("document", payload.document);
  formData.append("template_name", payload.template_name);
  try {
    return API.post(`/lots/templates`, formData).then((res) => {
      if (res && res.status && res.status === 201) {
        dispatch({
          type: ADD_TEMPLATE,
          payload: res?.data?.data,
        });
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

// to update template
export const updateTemplate = (templateId, payload) => async (dispatch) => {
  const formData = new FormData();
  formData.append("document", payload.document);
  formData.append("template_name", payload.template_name);
  try {
    return API.put(`/lots/templates/${templateId}`, formData).then((res) => {
      if (res && res.status && res.status === 200) {
        dispatch({
          type: UPDATE_TEMPLATE,
          payload: res?.data?.data,
        });
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

// to delete template
export const deleteTemplate = (templateId) => async (dispatch) => {
  try {
    return API.delete(`/lots/templates/${templateId}`).then((res) => {
      if (res && res?.status && res?.status === 200) {
        dispatch({
          type: DELETE_TEMPLATE,
          payload: templateId,
        });
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};
